// WP-0.7 (§18.1 amounts, SE-7): the single money-rendering component. Formats through the
// engine (one formatter everywhere, FX-5), carries the `amount` class for tabular figures,
// and marks itself for the global privacy blur when privacy mode is on.
import { formatMoney, fromMinor, type CurrencyCode, type GroupingMode } from '@pfos/engine';
import { usePrivacyBlurred } from '../lib/privacy';

export function Amount({
  currency,
  minorUnits,
  grouping,
  className = '',
}: {
  currency: CurrencyCode;
  minorUnits: number;
  grouping?: GroupingMode;
  className?: string;
}): React.JSX.Element {
  const blurred = usePrivacyBlurred();
  const text = formatMoney(fromMinor(currency, minorUnits), grouping ? { grouping } : undefined);
  return (
    <span className={`amount ${className}`.trim()} data-privacy-blurred={blurred}>
      {text}
    </span>
  );
}
